import {
  ECustomerAuthorizationEndpoints,
  customersAuthorizationApi
} from '../api';
import { EGerdauService } from '../EGerdauService';

export enum EHelpFileEndpoint {
  PLAIN_ORDERS = '/outros/pedidos-planos',
  ORDERS = '/outros/meus-pedidos',
  PURCHASE = '/comprar/guia-comprar-gmais',
  PURCHASE_SELECTING = '/comprar/selecionando-itens',
  PURCHASE_CATALOG = '/comprar/vitrine',
  PURCHASE_SHEET = '/comprar/planilha',
  PURCHASE_HISTORIC = '/comprar/historico',
  INVOICES = '/outros/minhas-financas',
  DASHBOARD = '/outros/painel-gestao',
  ACCESS_MANAGEMENT = '/outros/gestao-usuarios',
  HELP_LOGIN = '/outros/login',
  CORTE_DOBRA_MODEL = '/cd/maquete-cd',
  CORTE_DOBRA_REVIEW = '/cd/revisar-cd',
  CORTE_DOBRA_BUY = '/cd/comprar-cd',
  CREDIT_RENEW = '/outros/renovacao-credito',
  HELP_AREA = '/outros/ajuda'
}

export class HelpMenuService extends EGerdauService {
  static async getHelpFile(endpoint: EHelpFileEndpoint): Promise<string> {
    const headers = new HelpMenuService().getHeaders();
    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.HELP_MENU}${endpoint}`,
      { headers }
    );

    return response.data as string;
  }
}
